/**
 * @link https://mui.com/material-ui/react-slider/
 */

import * as React from 'react';
import {Box, Stack, Slider, Divider, Typography} from "@mui/material";
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeSlider() {

  const [value, setValue] = React.useState(30);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const valuetext = (value) => {
    return `${value}°C`;
  };

  return (
    <>
      <Box width={300}>
        <Slider
          size="small"
          defaultValue={70}
          aria-label="Slider small"
          valueLabelDisplay="auto"/>
        <Slider
          size="small"
          defaultValue={70}
          aria-label="Disabled slider"
          valueLabelDisplay="auto"
          disabled />
        <Slider
          defaultValue={50}
          aria-label="Default"
          valueLabelDisplay="auto" />
      </Box>
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Slider with icon legend</Typography></Divider>
      <Box sx={{width: 200}}>
        <Stack spacing={2} direction="row" sx={{mb: 1}} alignItems="center">
          <VolumeDown color={"lightBlue"} />
          <Slider aria-label="Volume" value={value} onChange={handleChange} />
          <VolumeUp color={"middleBlue"} />
        </Stack>
      </Box>
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Discrete Slider (Steps)</Typography></Divider>
      <Box sx={{width: 300}}>
        <Slider
          aria-label="Temperature"
          defaultValue={30}
          getAriaValueText={valuetext}
          valueLabelDisplay="auto"
          step={10}
          marks
          min={10}
          max={110}
        />
        <Slider defaultValue={30} step={10} marks min={10} max={110} disabled />
      </Box>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic Sliders */}
  <Box width={300}>
    {/* Small size slider */}
    <Slider
      size="small"
      defaultValue={70}
      aria-label="Small slider"
      valueLabelDisplay="auto"
    />
    
    {/* Default size slider */}
    <Slider
      defaultValue={50}
      aria-label="Default slider"
      valueLabelDisplay="auto"
    />
    
    {/* Disabled slider */}
    <Slider
      defaultValue={30}
      aria-label="Disabled slider"
      valueLabelDisplay="auto"
      disabled
    />
  </Box>
  
  {/* Slider with icon legend */}
  <Box sx={{ width: 200 }}>
    <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
      <VolumeDown />
      <Slider
        aria-label="Volume"
        value={30}
        onChange={(event, newValue) => console.log(newValue)}
      />
      <VolumeUp />
    </Stack>
  </Box>
  
  {/* Discrete Slider with steps and marks */}
  <Box sx={{ width: 300 }}>
    <Slider
      aria-label="Temperature"
      defaultValue={30}
      getAriaValueText={(value) => \`\${value}°C\`}
      valueLabelDisplay="auto"
      step={10}
      marks
      min={10}
      max={110}
    />
  </Box>
</>`} 
        scope={{ 
          React, 
          Box, 
          Stack, 
          Slider, 
          Typography, 
          VolumeDown, 
          VolumeUp 
        }} 
      />
    </>
  )
}